export enum ITenantFeature {
    CREDITS = "credits",
    USER_JOBS = "userJobs",
    JOBS = "jobs",
    AI = "ai",
    PreferencesWizard = "preferencesWizard",
    ATS_SCAN = "atsScan",
}

interface ITenantFeatureConfig {
    [ITenantFeature.CREDITS]: boolean;
    [ITenantFeature.USER_JOBS]: boolean;
    [ITenantFeature.JOBS]: boolean;
    [ITenantFeature.AI]: boolean;
    [ITenantFeature.PreferencesWizard]: boolean;
    [ITenantFeature.ATS_SCAN]: boolean;
}

export interface ITenantImageConfig {
    primaryLogo: string;
    mobileLogo: string;
    favIcon: string;
    footerLogo: string;
}

interface ITenantThemeConfig {
    primary: {
        "primary-50": number[];
        "primary-100": number[];
        "primary-200": number[];
        "primary-300": number[];
        "primary-400": number[];
        "primary-500": number[];
        "primary-600": number[];
        "primary-700": number[];
        "primary-950": number[];
        "primary-800": number[];
        "primary-900": number[];
    };
    gradient: {
        "primary-from": string;
        "primary-to": string;
        "credits-from": string;
        "credits-to": string;
    };
}

export interface ITenant {
    id: string;
    name: string;
    subdomain: string;
    features: ITenantFeatureConfig;
    images: ITenantImageConfig;
    theme: ITenantThemeConfig;
    socialLinks: {
        twitter?: string;
        linkedin?: string;
        facebook?: string;
        instagram?: string;
        youtube?: string;
    };
    externalLinks: {
        termsOfService: string;
        privacyPolicy: string;
        homepage: string;
    };
    contactEmail?: string;
    tagLine?: string;
}
